export const CHANNEL_PACKAGES_STALE_TIME = 60 * 1000 * 60; // 1 hour
